export const FONT_FAMILY = {
  heading: `'Playfair Display', cursive`,
  fantasy: `'Playfair Display', cursive`,
  body: `'Cormorant Upright', serif`,
};
